import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

// Multi-select filter using the same Tom Select library as shelter_selector.
export default class UptimeSelectController extends Controller {
  static values = { placeholder: String }

  connect () {
    this.tomSelect = new TomSelect(this.element, {
      create: false,
      plugins: ['remove_button'],
      sortField: { field: 'text', direction: 'asc' },
      searchField: ['text'],
      placeholder: this.placeholderValue || 'Select…'
    })
  }

  disconnect () {
    if (this.tomSelect) {
      this.tomSelect.destroy()
      this.tomSelect = null
    }
  }
}
